module.exports = __webpack_public_path__ + "img/manage-user.cfe259f.svg";